module.exports = __webpack_public_path__ + "static/media/h1.67f5c75f.mp4";